import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import React from 'react'
import { PERIOD_VALUES, PERIODS } from '../../hooks/usePeriodSelector'
import { t } from 'i18next'

type SelectPeriodProps = {
    periods: PERIODS,
    period: PERIOD_VALUES,
    onPeriodChange: (value: PERIOD_VALUES) => void,
}

function SelectPeriod({ periods, period, onPeriodChange }: SelectPeriodProps) {
    return (
        <FormControl sx={{ minWidth: '200px' }}>
            <InputLabel id="demo-simple-select-label">{t('period')}</InputLabel>
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={period}
                label={t('period')}
                onChange={(e) => onPeriodChange(e.target.value as PERIOD_VALUES)}
            >
                {
                    periods.map(p => (
                        <MenuItem key={p.value} value={p.value}>{p.key}</MenuItem>
                    ))
                }
            </Select>
        </FormControl>
    )
}

export default SelectPeriod